import { unref } from 'vue';
import { upcMapper } from './mappers';

/**
 * @param {import('@vueuse/core').MaybeRef<Product>} productRef
 * @returns {import('./types').UseUpc.UpcData}
 */
export const UpcParser = (productRef) => {
  const product = unref(productRef);
  /**
   * @type {{ upcMap: import('./types').UseUpc.UpcMap}}
   */
  const { upcMap } = product.traits.traitsMaps;
  /**
   * @type {import('./types').UseUpc.UpcDict}
   */
  const upcs = Object
    .fromEntries(
      Object.entries(product.relationships.upcs || {})
        .map(([key, value]) => [key, upcMapper(value)]),
    );

  return {
    upcMap,
    upcs,
  };
};

export default UpcParser;
